import { render, staticRenderFns } from "./BalaoMensagem.vue?vue&type=template&id=7706b624&"
import script from "./BalaoMensagem.vue?vue&type=script&lang=js&"
export * from "./BalaoMensagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports